<!--
 * @Description: 项目详情的弹窗 页面
 * @Author: mhf
 * @Date: 2024/1/27 12:58
-->
<template>
  <el-dialog
    width="900px"
    v-dialog-out
    append-to-body
    :title="title"
    :visible.sync="dialogVisible"
    :before-close="hideDialog"
    :close-on-click-modal="false"
  >
    <div class="dialog-body full-page-exclude">
      <el-form ref="form" :model="formData" label-width="96px">
        <el-form-item label="项目介绍：">
          <span> {{ formData.intro }} </span>
        </el-form-item>

        <el-form-item label="负责模块：">
          <span> {{ formData.responsibleModule }} </span>
        </el-form-item>

        <el-form-item label="其他描述：">
          <span> {{ formData.more }} </span>
        </el-form-item>

        <el-form-item label="部分截图：">
          <em v-if="proPicArr.length === 0"> 暂无截图... </em>
          <div v-else class="dialog-body-pic">
            <div class="public" v-for="item in proPicArr" :key="item">
              <el-image
                class="dialog-body-pic-pc"
                :src="`${proBaseUrl}/${item}` | imgFormat"
                :preview-src-list="[`${proBaseUrl}/${item}`] | imgFormat"
              ></el-image>
              <em> {{ item | getPicName }} </em>
            </div>
          </div>
        </el-form-item>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "detailDialog",
  components: {},
  props: {},
  filters: {
    getPicName(name) {
      let parts = name.split(".");
      parts.pop();
      return parts.join();
    },
  },
  data() {
    return {
      dialogVisible: false,
      title: "",
      formData: {},
      proBaseUrl: "",
      proPicArr: [],
    };
  },
  methods: {
    showDialog(data) {
      this.dialogVisible = true;
      this.title = data.title;
      this.formData = data.data;
      this.getProPicArr(data);
      /* 禁止鼠标滚动时页面滚动 */
      fullpage_api.setAllowScrolling(false);
      fullpage_api.setKeyboardScrolling(false);
    },

    hideDialog() {
      this.dialogVisible = false;
      this.formData = {};
      this.proPicArr = [];
      /* 激活鼠标滚动时页面滚动 */
      fullpage_api.setAllowScrolling(true);
      fullpage_api.setKeyboardScrolling(true);
    },

    getProPicArr(data) {
      // require.context() 是 Webpack 提供的一个方法，它允许你创建一个上下文，
      // 该上下文可以动态地按需加载模块。但是，这个方法不能直接接受运行时变量（如 data.type 和 data.data.name），
      // 因为 Webpack 在构建时就已经静态分析并确定了所有需要加载的资源路径。
      // const images = require.context('/public/img/qiYunProject/绍兴市考培管理系统', true, /\.(png|jpe?g|gif|svg)$/);
      // console.log(images.keys().map(images), "images")

      this.$axios
        .get(`/img/${data.type}/${data.data.name}`)
        .then((response) => {
          this.proBaseUrl = response.config.url;
          this.proPicArr = response.data;
        })
        .catch((e) => {
          this.proPicArr = [];
        });
    },
  },
  created() {},
  mounted() {},
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__body {
  padding: 20px 0 0 !important;
  max-height: 70vh;
  overflow-y: auto;
}

.dialog-body {
  padding: 0 20px 20px;
  max-height: 65vh;
  overflow-y: auto;

  &-pic {
    display: flex;
    flex-wrap: wrap;

    .public {
      width: 192px;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin: 10px 82px 0 0;

      &:nth-child(3n) {
        margin-right: 0 !important;
      }
    }

    &-pc {
      width: 192px;
      height: 91px;
    }
  }
}

::v-deep .el-form-item {
  margin-bottom: 0;

  &__label {
    font-weight: bolder;
  }
}
</style>
